import React, { useEffect, useRef, useState } from 'react';

type BasicDropdownProps = {
  options: string[];
  value: string;
  onChange: (selectedValue: string) => void;
  errorMessage: string;
  placeholder: string;
  label?: string;
  className?: string;
};

const BasicDropdown = (props: BasicDropdownProps) => {
  const {
    options,
    value,
    onChange,
    errorMessage,
    placeholder,
    label,
    className,
  } = props;

  const [category, setCategory] = useState<boolean>(false);
  const [selectedOptionIndex, setSelectedOptionIndex] = useState<number>();

  useEffect(() => {
    if (!options.length || !value) {
      setSelectedOptionIndex(undefined);
      return;
    }

    if (selectedOptionIndex) {
      if (options[selectedOptionIndex] === value) {
        return;
      }
    }

    const valueIndex = options.findIndex((option) => option === value);

    if (valueIndex !== -1) {
      setSelectedOptionIndex(valueIndex);
    } else {
      setSelectedOptionIndex(undefined);
    }
  }, [options, value]);

  useEffect(() => {
    const selectedOption =
      typeof selectedOptionIndex === 'number'
        ? options[selectedOptionIndex] || ''
        : '';

    if (value !== selectedOption) {
      onChange(selectedOption);
    }
  }, [selectedOptionIndex]);

  const onSelectedsetCategory = () => {
    setCategory(!category);
  };

  const setSelectedThenCloseDropdown = (index: number) => {
    setSelectedOptionIndex(index);
    setCategory(false);
    onChange(options[index]);
  };

  const handleKeyDown =
    (index: number) => (e: React.KeyboardEvent<HTMLElement>) => {
      switch (e.key) {
        case ' ':
        case 'SpaceBar':
        case 'Enter':
          e.preventDefault();
          setSelectedThenCloseDropdown(index);
          break;
        default:
          break;
      }
    };

  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const eventListner = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setCategory(false);
      }
    };

    document.addEventListener('mousedown', eventListner);

    return () => document.removeEventListener('mousedown', eventListner);
  }, []);

  const handleListKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
    switch (e.key) {
      case 'Escape':
        e.preventDefault();
        setCategory(false);
        break;
      case 'ArrowUp':
        e.preventDefault();
        setSelectedOptionIndex((index) => {
          if (typeof index !== 'number') {
            return 0;
          }

          return index - 1 >= 0 ? index - 1 : options.length - 1;
        });
        break;
      case 'ArrowDown':
        e.preventDefault();
        setSelectedOptionIndex((index) => {
          if (typeof index !== 'number') {
            return 0;
          }

          return index == options.length - 1 ? 0 : index + 1;
        });
        break;
      default:
        break;
    }
  };

  return (
    <div className="input-container">
      <label
        className={`text--regular fx-lable-name ${className}`}
        htmlFor="basic-dropdown"
      >
        {label || 'Name'}
      </label>
      <div
        className="mfone-dropdown-list-item"
        id="basic-dropdown"
        ref={dropdownRef}
      >
        <div
          className="Category-item input-form"
          aria-haspopup="listbox"
          onKeyDown={handleListKeyDown}
          onClick={onSelectedsetCategory}
        >
          <input
            readOnly
            value={value}
            className="mfone-cursor-pointer"
            placeholder={placeholder}
          />
          <div
            className={category ? 'dropdown-arrow-selected' : 'dropdown-arrow'}
          ></div>
        </div>
        <div
          style={{ display: category ? 'block' : 'none' }}
          className="dropdownList"
        >
          <ul
            className="category-list-items"
            role="listbox"
            aria-activedescendant={
              typeof selectedOptionIndex === 'number'
                ? options[selectedOptionIndex] || ''
                : ''
            }
            tabIndex={-1}
            onKeyDown={handleListKeyDown}
          >
            {/* <li className="disable-text">Popular currencies</li> */}
            {options.map((optionItem, index) => (
              <li
                key={index}
                id={optionItem}
                role="option"
                aria-selected={selectedOptionIndex == index}
                tabIndex={0}
                className={selectedOptionIndex == index ? 'selected-li' : ''}
                onKeyDown={handleKeyDown(index)}
                onClick={() => {
                  setSelectedThenCloseDropdown(index);
                }}
              >
                {optionItem}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <p className="text--red text--regular errorMessageDisplay">
        {errorMessage}
      </p>
    </div>
  );
};

export default BasicDropdown;
